/* eslint-disable prettier/prettier */
import * as React from "react";

export const usePatientInformation = (patient, patientLabs, csrfToken) => {
  const [open, setOpen] = React.useState<boolean>(true);
  const [labA1cs, setLabA1cs] = React.useState<any>(null);
  const [labBps, setLabBps] = React.useState<any>(null);
  const [labTcs, setLabTcs] = React.useState<any>(null);
  const [labHdls, setLabHdls] = React.useState<any>(null);
  const [editPatientInformation, setEditInformation] =
    React.useState<boolean>(false);
  const [addMedication, setAddMedication] = React.useState<boolean>(false);
  const [editMedication, setEditMedication] = React.useState<boolean>(null);
  const [showA1c, setShowA1c] = React.useState<boolean>(false);
  const [showBp, setShowBp] = React.useState<boolean>(false);
  const [showTc, setShowTc] = React.useState<boolean>(false);
  const [showHdl, setShowHdl] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<string>("labs");
  const [currentPatient, setCurrentPatient] = React.useState<any>(null);

  React.useEffect(() => {
    setLabA1cs(patientLabs?.hgb_data_values?.slice(0, 5));
    setLabBps([]);
    setLabTcs(patientLabs?.tc_values?.slice(0, 5));
    setLabHdls(patientLabs?.hdl_values?.slice(0, 5));
  }, [patientLabs]);

  React.useEffect(() => {
    setCurrentPatient(patient);
  }, [patient]);

  const closeModal = () => {
    setEditMedication(null);
    window.location.href = "/";
  };

  const formatDate = (dateString) => {
    let date = new Date(dateString);
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear()
    );
  };

  const formatDateSlashes = (dateString) => {
    let date = new Date(dateString);
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "-" +
      date.getFullYear()
    );
  };

  const formatDateDots = (dateString) => {
    let date = new Date(dateString);
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "." +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "." +
      date.getFullYear().toString().substr(-2)
    );
  };

  const calculateAge = (dateOfBirth) => {
    var today = new Date();
    var birthDate = new Date(dateOfBirth);
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age_now--;
    }
    return age_now;
  };

  return {
    open,
    closeModal,
    formatDate,
    formatDateDots,
    calculateAge,
    labA1cs,
    labBps,
    labTcs,
    labHdls,
    editPatientInformation,
    setEditInformation,
    addMedication,
    setAddMedication,
    showA1c,
    setShowA1c,
    showBp,
    setShowBp,
    showTc,
    setShowTc,
    showHdl,
    setShowHdl,
    expanded,
    setExpanded,
    editMedication,
    setEditMedication,
    formatDateSlashes,
    currentPatient,
    setCurrentPatient,
  };
};
